import { CreateSuperAdminActionTypes, CreateForgotPasswordActionTypes, getPaymentsDetailsActionTypes } from '../actionsTypes';

const initialState = {
    isCreatingEmployees: false,
    employees: {},
    createEmployeesError: '',

    // ForgotPassword
    isCreatingForgotPassword: false,
    forgotPassword: {},
    createForgotPasswordError: '',

    isGettingPayments: false,
    payments: [],
    gettingPaymentsError: '',
};

const paymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CreateSuperAdminActionTypes.INPROGRESS:
            return {
                ...state,
                isCreatingEmployees: true,
            };
        case CreateSuperAdminActionTypes.SUCCESS:
            return {
                ...state,
                employees: action.payload,
                isCreatingEmployees: false,
            };
        case CreateSuperAdminActionTypes.FAILED:
            return {
                ...state,
                isCreatingEmployees: false,
                createEmployeesError: action.error,
            };
        case CreateSuperAdminActionTypes.RESET_ERROR:
            return {
                ...state,
                createEmployeesError: '',
            };
        case CreateForgotPasswordActionTypes.INPROGRESS:
            return {
                ...state,
                isCreatingForgotPassword: true,
            };
        case CreateForgotPasswordActionTypes.SUCCESS:
            return {
                ...state,
                forgotPassword: action.payload,
                isCreatingForgotPassword: false,
            };
        case CreateForgotPasswordActionTypes.FAILED:
            return {
                ...state,
                isCreatingForgotPassword: false,
                createForgotPasswordError: action.error,
            };
        case CreateForgotPasswordActionTypes.RESET_ERROR:
            return {
                ...state,
                createForgotPasswordError: '',
            };
        case getPaymentsDetailsActionTypes.INPROGRESS:
            return {
                ...state,
                isGettingPayments: true,
            };
        case getPaymentsDetailsActionTypes.SUCCESS:
            return {
                ...state,
                payments: action.payload,
                isGettingPayments: false,
            };
        case getPaymentsDetailsActionTypes.FAILED:
            return {
                ...state,
                isGettingPayments: false,
                gettingPaymentsError: action.error,
            };
        case getPaymentsDetailsActionTypes.RESET_ERROR:
            return {
                ...state,
                gettingPaymentsError: '',
            };
        default:
            return state;
    }
};

export default paymentsReducer;